import { HttpBadStatusCodeError, HttpCancelError, HttpTimeoutError } from '@cian/peperrors/shared';
import { CircuitBreakerError } from '../../errors/circuitBreakerError.js';
export class TelemetryHook {
    telemetry;
    isEnabled;
    telemetryKey;
    startDate;
    constructor(params) {
        this.telemetry = params.telemetry;
        this.isEnabled = params.context.telemetryEnabled;
        this.telemetryKey = getKey(params.context.requestedServerName, params.context.pathSimplified);
    }
    onRequest() {
        this.startDate = Date.now();
    }
    onResponse() {
        if (this.isEnabled) {
            this.telemetry.timer(this.telemetryKey, this.timeDiff);
            this.telemetry.increment(`${this.telemetryKey}.success`);
        }
    }
    onError(error) {
        if (this.isEnabled) {
            if (error instanceof CircuitBreakerError) {
                this.telemetry.increment(`${this.telemetryKey}.fail.circuit_breaker`);
                return;
            }
            if (error instanceof HttpTimeoutError) {
                this.telemetry.timer(this.telemetryKey, this.timeDiff);
                this.telemetry.increment(`${this.telemetryKey}.fail.timeout`);
                return;
            }
            if (error instanceof HttpCancelError) {
                this.telemetry.timer(this.telemetryKey, this.timeDiff);
                this.telemetry.increment(`${this.telemetryKey}.fail.cancel`);
                return;
            }
            if (error instanceof HttpBadStatusCodeError) {
                this.telemetry.timer(this.telemetryKey, this.timeDiff);
                this.telemetry.increment(`${this.telemetryKey}.fail.http_error_${error.statusCode}`);
                return;
            }
            this.telemetry.increment(`${this.telemetryKey}.fail.error_${normalize(error.name)}`);
        }
    }
    get timeDiff() {
        return Date.now() - this.startDate;
    }
}
export function normalize(str) {
    return str.toLowerCase().replace(/\W+/g, '-').replace(/^-+/, '').replace(/-+$/, '') || '-';
}
export function getKey(host, path) {
    return ['external', 'http', normalize(host), normalize(path)].join('.');
}
//# sourceMappingURL=TelemetryHook.js.map